import Buttons from "../../../../../../components/ui/button/Buttons";
import FormSelectField from "../../../../../../components/finalForms/formFields/FormSelectField";
import { useEffect, useState } from "react";
import { useLazyGetInstrumentTypeListQuery } from "../../../../../../app/services/commonAPI";
import { useExportContractCostMutation } from "../../../../../../app/services/contractAPI";
import { saveAs } from 'file-saver';

const ExportModelContractCosts = () => {
  const [instrumentTypes, setInstrumentTypes] = useState([]);
  const [selectedInstrumentTypes, setSelectedInstrumentTypes] = useState();

  const [getInstrumentTypes, {
    isFetching: isInstrumentFetching,
    isSuccess: isInstrumentSuccess,
    data: instrumentTypeData,
  },] = useLazyGetInstrumentTypeListQuery();

  const [exportContractCost, {
    isLoading: isexporting,
    isSuccess: isAllexported,
    data: exportAllData
  }] = useExportContractCostMutation();

  useEffect(() => {
    getInstrumentTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isInstrumentFetching && isInstrumentSuccess && instrumentTypeData) {
      const options = instrumentTypeData.map(x => ({
        value: x.sInstrumentTypeKey === "" ? "" : x.sInstrumentTypeKey,
        label: x.sInstrumentType === "" ? "All" : x.sInstrumentType
      }));
      setInstrumentTypes(options);
      setSelectedInstrumentTypes(options[0]);
    }
  }, [isInstrumentFetching, isInstrumentSuccess, instrumentTypeData]);


  useEffect(() => {
    if (!isexporting && isAllexported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `ModelContractCosts.xlsx`);
    }
  }, [isexporting, isAllexported, exportAllData]);

  const handleExportCost = () => {
    const request = {
      psInstrumentType: selectedInstrumentTypes?.value,
      pbIncludeInactive: false
    }
    exportContractCost(request)
  }

  const handleDropdownChange = (dataField, selectedOption) => {
    setSelectedInstrumentTypes(selectedOption);
  };

  const handleClear = () => {
    setSelectedInstrumentTypes(null);
  };

  return (
    <div className="row p-2">
      <div className="col-9">
        <FormSelectField
          fieldSetting={
            { options: instrumentTypes, placeholder: "Select Instrument Type" }
          }
          options={instrumentTypes}
          value={selectedInstrumentTypes}
          onChange={handleDropdownChange}
          labelName="Instrument Type :"
          isRequired={true}
        />
      </div>
      <div className="col-12">
        <div className="d-flex justify-content-center button-submit mb-2 mt-3">
          <Buttons
            buttonText="Export"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handleExportCost}
          />
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={handleClear}
          />
        </div>
      </div>
    </div>
  );
};

export default ExportModelContractCosts;
